import React, { FC } from "react";
import { useDataSourcesQuery, useSavedExportSettingsQuery } from "../../../../../bulkexport/api";
import { useSubscriptionEditProviderContext } from "../../../../providers";
import { BulkExportPayload, SubscriptionItemType } from "../../../../types";
import { useStyles } from "./SubscriptionsSourceNameBulkExport.styles";

export const SubscriptionsSourceNameBulkExport: FC = () => {
  const classes = useStyles();
  const { dataSources } = useDataSourcesQuery();
  const { savedExportSettings } = useSavedExportSettingsQuery();
  const {
    state: { currentSubscriptionItem },
  } = useSubscriptionEditProviderContext();
  const dataSourceItem = dataSources?.find((ds) => ds.identifier === (currentSubscriptionItem?.payload as BulkExportPayload)?.cubeId);
  const dataSourceGroup = dataSources?.find((ds) => ds.id === dataSourceItem?.parentId);
  const bulkExportSourceName = `${dataSourceGroup?.name} > ${dataSourceItem?.name}`;
  const isSavedBulkExport = currentSubscriptionItem.type === SubscriptionItemType.SavedBulkExport;
  const subscriptionName = isSavedBulkExport
    ? savedExportSettings?.find((setting) => setting?.id === currentSubscriptionItem?.payload?.savedSettingId)?.name
    : undefined;
  return <span className={classes.root}>{isSavedBulkExport ? subscriptionName : bulkExportSourceName}</span>;
};
